<template>
  <div class="headerContainer">
    <div class="wrapper">
      <img alt="logo" src="../assets/jioMartLogo.svg">
      <div class="rhs">
        <!-- <img alt="user" src="../assets/\verified_user.png"> -->
        <div v-if="!!sellerId && showSellerId" class="info">Seller ID: {{sellerId}} </div>
        <button v-if="!!sellerId & showSellerId" class="linkBtn" @click="onSwitchClick"> Switch</button>
        <div class="msg">{{showRole()}} </div>
        <!-- <img class="help" alt="Vue logo" src="../assets/help.svg">
        <img alt="notify" src="../assets/notify.svg">
        <img class="profile" alt="Vue logo" src="../assets/profile.svg"> -->
        <button v-if="showLogoutButton" class="logoutButton" @click="logout">Logout</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { clearCookie, fetchWithAuthUserId, getCookie } from '../services/campaignService'
import { useRouter } from 'vue-router';
import { API_AUTH_URL } from '../constants/index';
import router from '../router';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Header',
  props: {
    msg: String
  },
  setup() {
    const router = useRouter();

    const getCurrentRouteName = () => {
      return router.currentRoute.value.name;
    };

    return { ...mapGetters(['getCurrentRouteName']), getCurrentRouteName };
  },
  computed: {
    ...mapState(['sellerId']),
    showLogoutButton() {
      if(this.getCurrentRouteName() === 'StaticTnCPage'){
        return false;
      }else{
        return getCookie('token') && this.getCurrentRouteName() !== 'OAuth2HomePage' && this.getCurrentRouteName() !== 'UnAuthorizedPage';
      }
    },
    showSellerId() {
      let role = getCookie('role');
      return role !== 'SELLER' && role !== 'BRAND'
    },
  },
  methods: {
    ...mapActions(['setSellerId']),
    async logout() {
     
      // Perform logout actions (e.g. clear session data, redirect to login page)
      try {
          const requestOptions = {
              method: 'POST',
              // headers: { 'Content-Type': 'application/json'},
          };
          const url = `${API_AUTH_URL}/v1/logout`;

          await fetchWithAuthUserId(url, requestOptions)
          .then(res=>res.json())
          .then(data => {
            if (data?.code === 200) {
              clearCookie('token');
              clearCookie('sellerId');
              clearCookie('role');
              clearCookie('tncAcceptance');
              clearCookie('userEmail');
              clearCookie('userId');
              clearCookie('ipAddress');
              clearCookie('twoFactorRegistered');
              this.$router.go('/');
            }else if(data?.message === 'Invalid token'){
              router.push('/unauthorized');
            }
          }).catch(error => console.log(error));
      } catch (error) {
        console.log(error);
      }
    },
    showRole() {
      let role = getCookie('role') ?? '';
      if(role == 'SUPERADMIN') role = 'SUPER ADMIN';
      else if(role == 'OPS') role = 'ADMIN';
      return role;
    },
    onSwitchClick() {
      this.setSellerId('');
      clearCookie('sellerId');
      router.push('/');
    }
  }
}
</script>

<style scoped>
@font-face {
    font-family: "Inter-Regular" ;
    src: url('../assets/fonts/Inter-Regular.ttf');
}
.headerContainer{
  font-family: "Inter-Regular";
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.06);
  background: #FFFFFF;
  /*position: fixed;*/
  width: 100%;
  z-index: 1;

}

.wrapper{
  display: flex;
  justify-content: space-between;
  max-width: 100%;
  margin: 0 auto;
  padding: 18px 25px;
}

.rhs {
  display: flex;
  align-items: center;
}

.help{
  margin: 0 26px;
}

.profile{
  margin-left: 28px;
}
.msg {
  font-family: 'Inter-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: right;
  color: #3C2E16;
  margin-left: 4px;
}
.logoutButton {
  margin-left: 28px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.logoutButton {
  background-color: #ff4d4d;
  color: #ffffff;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.logoutButton:hover {
  background-color: #cc3333;
}

.linkBtn {
    border: none;
    background: none;
    cursor: pointer;
    font-weight: 700;
    font-size: 12px;
    color: #2E31BE;
    margin-right: 16px;
}
.info {
  font-family: 'Inter-Regular';
  font-size: 12px;
  font-weight: 600;
  line-height: 16.8px;
  color: #9B9B9B;
  margin-right: 8px;
}
</style>
